import React, { useState } from "react";
import Header from "../components/Header";
import data from "../data/data.json";
import { useMediaQuery } from "react-responsive";

const Destination = () => {
  const destinationData = data.destinations;
  const [idChoice, setIdChoice] = useState(0);
 

  const handleChoice = (e) => {
    const buttons = document.querySelectorAll(".nav-planet");
    const planet = e.target.innerText;

    buttons.forEach((button) => {
      if (button === e.target) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });

    const choice = destinationData.find(
      (destination) => destination.name.toUpperCase() === planet
    );
    if (choice) {
      setIdChoice(destinationData.indexOf(choice));
    }

  };

  return (
    <div className="destination-container">
      <Header />
      <main className="destination-content wrapper">
        <h5>
          <span>01</span> Pick your destination
        </h5>
        <div className="main-content">
          <img src={destinationData[idChoice].images.png} alt="moon" />
          <div>
            <ul className="button-container">
              {destinationData.map((destination, index) => {
                return (
                  <li key={destination.name}>
                    <button
                      onClick={(e) => handleChoice(e)}
                      className={
                        index === 0 ? "nav-planet active" : "nav-planet"
                      }
                    >
                      {destination.name.toUpperCase()}
                    </button>
                  </li>
                );
              })}
            </ul>
            <div className="main-description">
              {<h1>{destinationData[idChoice].name}</h1>}
              <p>{destinationData[idChoice].description}</p>
            </div>
            <div className="footer-description">
              <div className="distance">
                <span className="subheading-2">avg. distance</span>
                <span className="subheading-1">
                  {destinationData[idChoice].distance}
                </span>
              </div>
              <div className="average">
                <span className="subheading-2">Est. travel time</span>
                <span className="subheading-1">
                  {destinationData[idChoice].travel}
                </span>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Destination;
